module.exports = __webpack_public_path__ + "static/media/eventCallback.4f0da096.svg";